import createIcon from '@/lib/create-icon'

const LogoutIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 19' fill='none'>
    <path
      d='M11.25 8.75H15.75M15.75 8.75L14.25 10.25M15.75 8.75L14.25 7.25M8.25 14.75H11.25C12.0788 14.75 12.75 14.0788 12.75 13.25V12.5M12.75 5V4.25C12.75 3.42125 12.0788 2.75 11.25 2.75L3.75 2.75M2.25 4.28522V12.7477C2.25 13.2896 2.54229 13.7894 3.01461 14.0551L6.01461 15.7426C7.01451 16.305 8.25 15.5825 8.25 14.4352V5.89691C8.25 5.34458 7.94645 4.83693 7.45989 4.57553L4.45989 2.96384C3.46058 2.42698 2.25 3.15084 2.25 4.28522Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'LogoutIcon'
)

export default LogoutIcon
